<template>
    <div>
        <v-container class="toggle animated" fluid>
            <v-row dense>
                <!-- Search and Create Button -->
                <v-col cols="12" md="4">
                    <v-text-field
                        v-model="search"
                        @keyup="handleSearching()"
                        variant="outlined"
                        prepend-inner-icon="mdi-magnify"
                        :label="$t('TableHeaders.Search')"
                        density="comfortable"
                        solo
                        hide-details
                        class="rounded-lg"
                        color="white"
                        clearable
                        style="font-family: Saira Condensed, sans-serif;"
                    ></v-text-field>
                </v-col>
                <v-col class="text-right" cols="12" md="8">
                    <v-btn
                        @click="showAddRaffleDialogue()"
                        prepend-icon="mdi-plus"
                        class="mt-2 rounded-lg"
                        color="white"
                        height="40px"
                        elevation="2"
                        style="font-family: Saira Condensed, sans-serif;"
                    >
                        {{ $t('Buttons.Create_Raffle') }}
                    </v-btn>
                </v-col>

                <!-- <v-col cols="12" class="pt-2">
                    <v-expansion-panels multiple color="black">
                        <v-expansion-panel class="guide-panel">
                            <v-expansion-panel-title class="font-weight-bold">
                                📌 {{ $t('Raffle_System_Guide.Header') }}
                            </v-expansion-panel-title>
                        <v-expansion-panel-text>
                            <v-list class="guide-panel-content text-subtitle-2" dense>
                                <v-list-item>
                                    {{ $t('Raffle_System_Guide.Intro') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold; font-size: medium;">{{ $t('Raffle_System_Guide.Status_Guide.HEADER') }}</p>
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">ACTIVE</p> - {{ $t('Raffle_System_Guide.Status_Guide.ACTIVE') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">STARTED</p> - {{ $t('Raffle_System_Guide.Status_Guide.STARTED') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">STOPPED</p> - {{ $t('Raffle_System_Guide.Status_Guide.STOPPED') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">ENDED</p> - {{ $t('Raffle_System_Guide.Status_Guide.ENDED') }}
                                </v-list-item>

                                <v-list-item>
                                    <p style="font-weight: bold; font-size: medium;">{{ $t('Raffle_System_Guide.Buttons_Guide.HEADER') }}</p>
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">START ENTRIES</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.START_ENTRIES') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">VIEW ENTRIES</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.VIEW_ENTRIES') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">DRAW</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.DRAW') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">STOP ENTRIES</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.STOP_ENTRIES') }}
                                </v-list-item> 
                                <v-list-item>
                                    <p style="font-weight: bold;">END RAFFLE</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.END_RAFFLE') }}
                                </v-list-item>
                                <v-list-item>
                                    <p style="font-weight: bold;">VIEW WINNERS</p> - {{ $t('Raffle_System_Guide.Buttons_Guide.VIEW_WINNERS') }}
                                </v-list-item>
                            </v-list>
                        </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col> -->


                <!-- Raffle Cards -->
                <v-col cols="12" class="mt-2">
                    <v-row v-if="loading">
                        <v-col cols="12">
                            <v-progress-linear indeterminate color="secondary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                        </v-col>
                    </v-row>

                    <v-row v-if="!loading && data.length === 0">
                        <v-col cols="12" class="text-center font-weight-bold mt-8">
                            No raffle entries to show
                        </v-col>
                    </v-row>

                    <v-row v-if="!loading && paginatedData.length > 0" dense>
                        <v-col v-for="(item, index) in paginatedData" :key="index" cols="12" md="3">
                            <v-card elevation="0" color="white" class="pa-4 rounded-l position-relative">
                                <v-row dense class="align-center">
                                    <!-- Raffle Title (Left) -->
                                    <v-col cols="9">
                                        <div class="text-h6 font-weight-bold" style="font-family: Saira Condensed, sans-serif;">
                                            {{ item.name }}
                                        </div>
                                    </v-col>

                                    <!-- Actions Menu (Right) -->
                                    <v-col v-if="item.status !== 'stopped'" cols="3" class="text-right">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ props }">
                                                <v-btn v-bind="props" icon variant="text" size="small">
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list>
                                                <v-list-item @click="showEditDialog(item)" v-if="item.status == 'active' || item.status == 'started'">
                                                    <v-list-item-title>
                                                        <v-icon small class="mr-2">mdi-pencil</v-icon> {{ $t('Buttons.Edit') }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                                <v-list-item @click="showDeleteDialog(item)" v-if="item.status == 'active' || item.status == 'ended'">
                                                    <v-list-item-title>
                                                        <v-icon small class="mr-2">mdi-delete</v-icon> {{ $t('Buttons.Delete') }}
                                                    </v-list-item-title>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>

                                    <!-- Status -->
                                    <v-col cols="6">
                                        <div class="text-body-2 font-weight-bold">{{ $t('Fields_Label.Raffle.Status') }}:</div>
                                        <v-chip :color="getStatusColor(item.status)" class="rounded-pill text-body-2">
                                            {{ formatStatus(item.status) }}
                                        </v-chip>
                                    </v-col>

                                    <!-- Entry Cost (Replaces Actions Section) -->
                                    <v-col cols="6">
                                        <div class="text-body-2 font-weight-bold">{{ $t('Fields_Label.Raffle.Entry_Cost') }}:</div>
                                        <div class="d-flex align-center">
                                            <v-icon small class="mr-1">mdi-currency-usd</v-icon>
                                            <span class="text-body-2">{{ item.entryCost }}</span>
                                        </div>
                                    </v-col>

                                    <!-- Deadline Section -->
                                    <v-col cols="12">
                                        <v-row dense>
                                            <v-col cols="6">
                                                <div class="text-body-2 font-weight-bold">{{ $t('Fields_Label.Raffle.Deadline') }}:</div>
                                                <div class="d-flex align-center">
                                                    <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
                                                    <span class="text-body-2">{{ formatDate(item.deadline) }}</span>
                                                </div>
                                            </v-col>
                                            <v-col v-if="item.winners?.length > 0 || item.status == 'ended'" cols="6">
                                                <div class="text-body-2 font-weight-bold">{{ $t('Fields_Label.Raffle.Winners') }}:</div>
                                                <div class="d-flex align-center">
                                                    <v-icon small class="mr-1">mdi-trophy</v-icon>
                                                    <span class="text-body-2"> {{ item.winners?.length || 0 }} / {{ item.numberOfWinners || 0 }}</span>
                                                </div>
                                            </v-col>
                                            <v-col v-else cols="6">
                                                <div class="text-body-2 font-weight-bold">{{ $t('Fields_Label.Raffle.Total_Entries') }}:</div>
                                                <div class="d-flex align-center">
                                                    <v-icon small class="mr-1">mdi-ticket-account</v-icon>
                                                    <span class="text-body-2"> {{ item.totalEntries || 0 }}</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>

                                <!-- Buttons -->
                                <v-row dense class="mt-3">
                                    <v-col v-if="item.status == 'active'" cols="12">
                                        <v-btn @click="showStartDialog(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-play" color="black">
                                            {{ $t('Fields_Label.Raffle.Start_Entries') }}
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="item.status == 'started'" cols="6">
                                        <v-btn @click="showRaffleEntries(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-eye" color="green">
                                            {{ $t('Fields_Label.Raffle.View_Entries') }}
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="item.status == 'started'" cols="6">
                                        <v-btn @click="showStopDialog(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-stop" color="red darken-2">
                                            {{ $t('Fields_Label.Raffle.Stop_Entries') }}
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="item.status == 'ended'" cols="12">
                                        <v-btn @click="showRaffleEntries(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-eye" color="green">
                                            {{ $t('Fields_Label.Raffle.View_Winners') }}
                                        </v-btn>
                                    </v-col>

                                    <v-col v-if="item.status == 'stopped'" cols="12">
                                        <v-row dense><v-col cols="6">
                                                <v-btn @click="showSlotMachine(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-dice-multiple" color="black darken-2">
                                                    {{ $t('Fields_Label.Raffle.Draw') }}
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-btn @click="showEndDialog(item)" elevation="0" class="w-100 text-body-2 rounded-l" prepend-icon="mdi-close-circle" color="red darken-2">
                                                    {{ $t('Fields_Label.Raffle.End_Raffle') }}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                    <!-- Pagination Controls -->
                    <v-row v-if="!loading && data.length > itemsPerPage" class="mt-4">
                        <v-col cols="12" class="d-flex justify-center align-center">
                            <!-- Previous Button -->
                            <v-btn
                                @click="currentPage--"
                                :disabled="currentPage === 1"
                                icon
                                variant="text"
                                size="large"
                                color="white"
                                class="mr-2"
                            >
                                <v-icon>mdi-chevron-left</v-icon>
                                <v-tooltip activator="parent" location="top">Previous</v-tooltip>
                            </v-btn>

                            <!-- Numbered Pagination -->
                            <v-pagination
                                v-model="currentPage"
                                :length="totalPages"
                                :total-visible="7"
                                prev-icon="mdi-chevron-left"
                                next-icon="mdi-chevron-right"
                                color="white"
                            ></v-pagination>

                            <!-- Next Button -->
                            <v-btn
                                @click="currentPage++"
                                :disabled="currentPage === totalPages"
                                icon
                                variant="text"
                                size="large"
                                color="white"
                                class="ml-2"
                            >
                                <v-icon>mdi-chevron-right</v-icon>
                                <v-tooltip activator="parent" location="top">Next</v-tooltip>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div class="text-caption text-center mt-2">
                        Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to 
                        {{ Math.min(currentPage * itemsPerPage, data.length) }} of 
                        {{ data.length }} items
                    </div>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            v-model="startDialog"
            width="450"
            persistent
            style="font-family: 'Saira Condensed', sans-serif"
        >
            <v-card color="white" rounded="xl" class="pa-6" elevation="14">
                <!-- Warning Icon + Title -->
                <div class="d-flex justify-center">
                    <v-icon size="50" color="red darken-2" class="mb-2">
                        mdi-alert-circle-outline
                    </v-icon>
                </div>
                <v-card-text class="text-center">
                    <span class="font-weight-bold text-h5" style="letter-spacing: 0.5px; line-height: 1.4;">
                        {{ $t('AlertDialog.Raffles.Confirm_Start') }}
                    </span>
                </v-card-text>

                <!-- Divider -->
                <v-divider class="my-4"></v-divider>

                <!-- Action Buttons -->
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        @click="startDialog = false"
                        :disabled="loadingStart"
                        variant="outlined"
                        color="grey darken-2"
                        class="px-6 py-2 rounded-lg text-body-1"
                    >
                        <v-icon left class="mr-2">mdi-close</v-icon>
                        {{ $t('Buttons.Cancel') }}
                    </v-btn>

                    <v-btn 
                        @click="changeRaffleAction('start', itemToStart._id); startDialog = false" 
                        variant="elevated"
                        class="px-6 py-2 rounded-lg text-body-1"
                        style="background: linear-gradient(45deg, #f44336, #c62828); color: white;"
                    >
                        <v-icon left class="mr-2">mdi-check-circle</v-icon>
                        {{ $t('Buttons.Confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="endDialogue"
            width="450"
            persistent
            style="font-family: 'Saira Condensed', sans-serif"
        >
            <v-card color="white" rounded="xl" class="pa-6" elevation="14">
                <!-- Warning Icon + Title -->
                <div class="d-flex justify-center">
                    <v-icon size="50" color="red darken-2" class="mb-2">
                        mdi-alert-circle-outline
                    </v-icon>
                </div>
                <v-card-text class="text-center">
                    <span class="font-weight-bold text-h5" style="letter-spacing: 0.5px; line-height: 1.4;">
                        {{ $t('AlertDialog.Raffles.Confirm_End') }}
                    </span>
                </v-card-text>

                <!-- Divider -->
                <v-divider class="my-4"></v-divider>

                <!-- Action Buttons -->
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        @click="endDialogue = false"
                        :disabled="loadingStart"
                        variant="outlined"
                        color="grey darken-2"
                        class="px-6 py-2 rounded-lg text-body-1"
                    >
                        <v-icon left class="mr-2">mdi-close</v-icon>
                        {{ $t('Buttons.Cancel') }}
                    </v-btn>

                    <v-btn 
                        @click="changeRaffleAction('end', itemToEnd._id); endDialogue = false" 
                        variant="elevated"
                        class="px-6 py-2 rounded-lg text-body-1"
                        style="background: linear-gradient(45deg, #f44336, #c62828); color: white;"
                    >
                        <v-icon left class="mr-2">mdi-check-circle</v-icon>
                        {{ $t('Buttons.Confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="stopDialog"
            width="450"
            persistent
            style="font-family: 'Saira Condensed', sans-serif"
        >
            <v-card color="white" rounded="xl" class="pa-6" elevation="14">
                <!-- Warning Icon + Title -->
                <div class="d-flex justify-center">
                    <v-icon size="50" color="red darken-2" class="mb-2">
                        mdi-alert-circle-outline
                    </v-icon>
                </div>
                <v-card-text class="text-center">
                    <span class="font-weight-bold text-h5" style="letter-spacing: 0.5px; line-height: 1.4;">
                        {{ $t('AlertDialog.Raffles.Confirm_Stop') }}
                    </span>
                </v-card-text>

                <!-- Divider -->
                <v-divider class="my-4"></v-divider>

                <!-- Action Buttons -->
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        @click="stopDialog = false"
                        :disabled="loadingStart"
                        variant="outlined"
                        color="grey darken-2"
                        class="px-6 py-2 rounded-lg text-body-1"
                    >
                        <v-icon left class="mr-2">mdi-close</v-icon>
                        {{ $t('Buttons.Cancel') }}
                    </v-btn>

                    <v-btn 
                        @click="changeRaffleAction('stop', itemToStop._id); stopDialog = false"
                        variant="elevated"
                        class="px-6 py-2 rounded-lg text-body-1"
                        style="background: linear-gradient(45deg, #f44336, #c62828); color: white;"
                    >
                        <v-icon left class="mr-2">mdi-check-circle</v-icon>
                        {{ $t('Buttons.Confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="deleteDialog"
            width="450"
            persistent
            style="font-family: 'Saira Condensed', sans-serif"
        >
            <v-card color="white" rounded="xl" class="pa-6" elevation="14">
                <!-- Warning Icon + Title -->
                <div class="d-flex justify-center">
                    <v-icon size="50" color="red darken-2" class="mb-2">
                        mdi-alert-circle-outline
                    </v-icon>
                </div>
                <v-card-text class="text-center">
                    <span class="font-weight-bold text-h5" style="letter-spacing: 0.5px; line-height: 1.4;">
                        {{ $t('AlertDialog.Raffles.Confirm_Delete') }}
                    </span>
                    <span class="font-weight-bold text-h5" style="letter-spacing: 0.5px; line-height: 1.4;">
                        <br><br>"{{ itemToDelete.name }}"
                    </span>
                </v-card-text>

                <!-- Divider -->
                <v-divider class="my-4"></v-divider>

                <!-- Action Buttons -->
                <v-card-actions class="d-flex justify-center">
                    <v-btn
                        @click="deleteDialog = false"
                        :disabled="loadingStart"
                        variant="outlined"
                        color="grey darken-2"
                        class="px-6 py-2 rounded-lg text-body-1"
                    >
                        <v-icon left class="mr-2">mdi-close</v-icon>
                        {{ $t('Buttons.Cancel') }}
                    </v-btn>

                    <v-btn @click="deleteRaffle(itemToDelete)" color="red"
                        variant="elevated"
                        class="px-6 py-2 rounded-lg text-body-1"
                        style="background: linear-gradient(45deg, #f44336, #c62828); color: white;"
                    >
                        <v-icon left class="mr-2">mdi-check-circle</v-icon>
                        {{ $t('Buttons.Confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            v-model="snackBar"
            :timeout="2500"
            :color="snackBarColor"
            location="top">
            <v-icon>mdi-alert-circle</v-icon>
            <span class="ml-2" style="font-family: Saira Condensed, sans-serif;">{{ snackText }}</span>
        </v-snackbar>

        <SlotMachineDialogue ref="SlotMachineDialogue" @end="endGiveaway"/>
        <RaffleDialogue ref="RaffleDialogue" v-on:refresh="init()" />
        <RaffleEntries ref="RaffleEntries"/>
    </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";
import SlotMachineDialogue from '../Dialogs/SlotMachineDialogue.vue';
import RaffleDialogue from '../Dialogs/RaffleDialogue.vue';
import RaffleEntries from '../Dialogs/Views/RaffleEntries.vue'

export default defineComponent({
    components: {
        SlotMachineDialogue,
        RaffleDialogue,
        RaffleEntries
    },
    data() {
        return {
            search: null,
            data: [],
            savedData: [],
            loading: true,

            // Pagination variables
            currentPage: 1,
            itemsPerPage: 12,

            stopDialog: false,
            startDialog: false,
            deleteDialog: false,
            endDialogue: false,
            itemToStart: [],
            itemToStop: [],
            itemToDelete: [],
            itemToEnd: [],

            snackBar: false,
            snackText: null,
            snackBarColor: 'green'
        };
    },
    computed: {
        filteredRaffles() {
            return this.raffles.filter((raffle) =>
            raffle.itemName.toLowerCase().includes(this.search.toLowerCase())
            );
        },
        totalPages() {
            return Math.ceil(this.data.length / this.itemsPerPage);
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.data.slice(start, end);
        }
    },
    methods: {
        async init() {
            const token = localStorage.getItem("maherco-admin-accesstoken");
            if (token) {
                await axios.get(process.env.VUE_APP_SERVER_URL + "/api/admin/raffles", {
                    headers: {
                    Authorization: `Bearer ${token}`,
                    "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
                    },
                }).then((res)=>{
                    if(res.data){
                        this.data = res.data.raffles;
                        this.savedData = res.data.raffles;
                        this.loading = false;
                    }
                }).catch((error) => {
                    if (error.response) {
                        if (error.response.status === 401) {
                                localStorage.removeItem("vuex");
                                localStorage.removeItem("maherco-admin-accesstoken");
                                window.location.reload();
                        } else {
                            console.log(`Error: ${error.response.status}`);
                        }
                    } 
                    else if (error.request) {
                        console.log('No response received', error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
                
            } else {
                console.warn("Unable to initialized Raffle Page. No token found");
            }
        },
        deleteRaffle(data){
            const token = localStorage.getItem('maherco-admin-accesstoken')
            axios.delete(process.env.VUE_APP_SERVER_URL + `/api/admin/raffles/${data._id}`, { 
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                }
            }).then((res)=>{
                if(res.data){
                    this.snackBar = true
                    this.snackText = 'Giveaway Succesfully Deleted'
                    this.snackBarColor = 'green';
                    this.init()
                    this.deleteDialog = false
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("maherco-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                } 
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        },
        changeRaffleAction(action, raffleId){
            const token = localStorage.getItem('maherco-admin-accesstoken')

            const currentTime = new Date().toISOString();
            let updateData = {};
            if (action === "start") {
                updateData.timeStarted = currentTime;
            } else if (action === "stop") {
                updateData.timeStopped = currentTime;
            } else if (action === "end") {
                updateData.timeEnded = currentTime;
            }
            axios.post(process.env.VUE_APP_SERVER_URL + `/api/admin/raffles/${raffleId}/${action}`, updateData , { 
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'x-admin-key': process.env.VUE_APP_X_ADMIN_KEY,
                }
            }).then((res)=>{
                if(res.data){
                    this.snackBar = true
                    this.snackText = 'Raffle Successfully Updated'
                    this.init()
                }
            }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("maherco-admin-accesstoken");
                            window.location.reload();
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                } 
                else if (error.request) {
                    console.log('No response received', error.request);
                } else {
                    console.log('Error', error.message);
                }
            });
        },
        handleSearching() {
            if (this.search == "" || !this.search) {
                this.data = [...this.savedData];
                this.currentPage = 1;
            }
            else {
                this.data = this.savedData.filter(
                    (data) =>
                        data.name
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase()) !== -1 
                );
                this.currentPage = 1;
            }
        },
        formatDate(dateString) {
            const options = { 
                year: "numeric", 
                month: "long", 
                day: "numeric", 
                hour: "2-digit", 
                minute: "2-digit", 
                second: "2-digit",
                hour12: true
            };
            return new Date(dateString).toLocaleString(undefined, options);
        },
        showSlotMachine(data){
            this.$refs.SlotMachineDialogue.initSlotMachine(data)
        },
        showAddRaffleDialogue(){
            this.$refs.RaffleDialogue.initAdd()
        },
        showEditDialog(data){
            this.$refs.RaffleDialogue.initUpdate(data)
        },
        showRaffleEntries(data) {
            this.$refs.RaffleEntries.initView(data)
        },
        showStopDialog(data){
            this.itemToStop = data
            this.stopDialog = true
        },
        showDeleteDialog(data){
            this.itemToDelete = data
            this.deleteDialog = true
        },
        showStartDialog(data){
            this.itemToStart = data
            this.startDialog = true
        },
        showEndDialog(data) {
            console.log(data);
            this.itemToEnd = data
            this.endDialogue = true
        },
        getStatusColor(status) {
            switch (status) {
                case 'active': return 'blue';
                case 'started': return 'green';
                case 'stopped': return 'red';
                case 'ended': return 'gray';
                default: return 'black';
            }
        },
        formatStatus(status) {
            switch (status) {
                case 'active': return 'Waiting to start';
                case 'started': return 'Started';
                case 'stopped': return 'Stopped';
                case 'ended': return 'Ended';
                default: return status;
            }
        }
    },
    mounted() {
        this.init();
    },
});
</script>

<style scoped>
    /* Search Bar */
    .search-bar {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        color: white;
    }
    
    /* Raffle List Container */
    .raffle-list {
        background: rgba(0, 0, 0, 0.6); /* Darker background for contrast */
        border-radius: 12px;
        padding: 12px;
    }
    
    /* Individual Raffle Items */
    .raffle-item {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 12px;
        margin-bottom: 10px;
        transition: transform 0.2s, background 0.2s;
    }
    .raffle-item:hover {
        transform: scale(1.02);
        background: rgba(255, 255, 255, 0.2);
    }
    
    /* Raffle Avatar */
    .raffle-avatar {
        border: 2px solid rgba(255, 255, 255, 0.3);
    }
    
    /* Raffle Title */
    .raffle-title {
        font-weight: bold;
        font-size: 1.2rem;
        color: #fff;
    }
    
    /* Raffle Description */
    .raffle-description {
        color: #bbb;
    }
    
    /* Raffle Meta Info */
    .raffle-meta {
        font-size: 0.9rem;
        color: #ddd;
    }

    /* Status Chip */
    .raffle-status {
        font-weight: bold;
    }
</style>